import { functionsURL } from './firebase';

export const registerUser = async (data) => {
    return await fetch(functionsURL+'/registerUser', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
}

export const resetPassword = async (data) => {
    return await fetch(functionsURL+'/resetPassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
}

export const createPasswordResetLink = async (data) => {
    return await fetch(functionsURL+'/createPasswordResetLink', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
}